<template>
  <v-autocomplete
    v-model="transition"
    :items="transitionItems"
    item-text="title"
    item-value="id"
    return-object
    hide-selected
    hide-details
    outline
    height="42"
    @change="change"
  >
    <template v-slot:item="data">
      <template>
        <v-list-tile-content>
          <v-list-tile-title>
            <v-layout>
              <span>{{ data.item.title }}</span>
              <v-spacer class="ml-3" />
              <v-icon small>
                {{ data.item.isNext ? 'east' : 'west' }}
              </v-icon>
              <span>{{ data.item.title }}</span>
            </v-layout>
          </v-list-tile-title>
        </v-list-tile-content>
      </template>
    </template>
  </v-autocomplete>
</template>
<script>
export default {
  props: ["value", "transitions"],
  data() {
    return {
      transition: null,
    };
  },
  computed: {
    transitionItems() {
      if (!this.transitions) {
        return [];
      }

      let transitionItems = [];
      if (this.transitions.next.length) {
        transitionItems = this.transitions.next.map((t) => t);
        transitionItems.forEach((t) => (t.isNext = true));
      }
      if (this.transitions.prev && this.transitions.next.length) {
        transitionItems.push({
          divider: true,
        });
        transitionItems.push({ ...this.transitions.prev, isPrev: true });
      }
      if (this.transitions.prev && !this.transitions.next.length) {
        transitionItems.push({ ...this.transitions.prev, isPrev: true });
      }

      if (transitionItems.find((t) => t.id !== this.value.id)) {
        transitionItems.push(this.value);
      }

      return transitionItems;
    },
  },
  watch: {
    value: {
      handler(val) {
        this.transition = val;
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    change() {
      this.$emit("input", this.transition);
    },
  },
};
</script>
<style>
.v-card .v-list .theme--light.v-divider {
  margin: 8px 0;
}
</style>